import { Container } from '@clearcover/atlas';
import { VersionedObjectDiff } from '@clearcover/core-app-types';
import { DisplayInsurableItemRelationship } from '@clearcover/core-app-types/dist/endpoints/getPolicy/displayInsurableItemRelationship';
import { formatDiff } from 'Policies/components/PolicyActivities/Common/Common';
import { CardSectionInfoPairs } from 'Shared/components';
import React, { FC } from 'react';

export type InsurableItemRelationshipChangeDetailsDiff = {
  diff: VersionedObjectDiff<DisplayInsurableItemRelationship>;
};

export const InsurableItemRelationshipChangeDetails: FC<
  InsurableItemRelationshipChangeDetailsDiff
> = ({ diff }) => {
  return (
    <div data-testid="insurable-item-relationship-change-details">
      <Container>
        <h4>Insurable Item Relationship Change</h4>
        <CardSectionInfoPairs
          headers={[
            'Insurable Item ID',
            'Insurable Item Party ID',
            'Relationship',
          ]}
          data={[
            formatDiff(
              diff.old?.insurableItemId ?? '',
              diff.new?.insurableItemId
            ),
            formatDiff(
              diff.old?.insurableItemPartyId ?? '',
              diff.new?.insurableItemPartyId
            ),
            formatDiff(diff.old?.relationship ?? '', diff.new?.relationship),
          ]}
        />
      </Container>
    </div>
  );
};
